import React from 'react'
import { PhoneInputProps } from 'common/components/core/PhoneInput'
import FieldWrapperUi from 'common/components/entities/Field/FieldWrapperUi'
import FieldIconUiNew from 'common/components/entities/Field/field-icon-ui'
import PhoneNumberFieldUiNew from 'common/components/entities/Field/phone-number-field-ui'
import { getLanguageCodeByLocale } from 'common/enums/LanguageCodeEnum'
import { BaseFieldInterface } from 'common/types/entities/field-interface'
import FieldErrors from 'publisher/components/FieldErrors'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { typedPageSelectors, useOptIn, usePage } from 'publisher/store'
import { getCustomerCountry } from 'publisher/store/optIn/optInSelectors'

export interface BasePublisherPhoneNumberFieldProps {
  entity: BaseFieldInterface
  value: string | undefined
  onChange: (value: string) => void
  errors: string[]
  isHidden?: boolean
}

export const BasePublisherPhoneNumberField = ({
  entity,
  value,
  onChange,
  errors,
  isHidden,
}: BasePublisherPhoneNumberFieldProps) => {
  const locale = usePage(typedPageSelectors.getLocale)

  const customerCountry = useOptIn(getCustomerCountry) || undefined

  const handlePhoneNumber: PhoneInputProps['onChange'] = ({
    unformatedPhone,
  }) => {
    onChange(unformatedPhone)
  }

  return (
    <StyleWrapper
      id={entity.htmlAttrId}
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      {typeof window !== 'undefined' && !isHidden && (
        <FieldWrapperUi>
          {entity.iconClassName && (
            <FieldIconUiNew
              color={entity.color}
              mobileColor={entity.mobileColor}
              fontSize={entity.fontSize}
              mobileFontSize={entity?.mobileFontSize}
              className={entity.iconClassName}
            />
          )}
          <PhoneNumberFieldUiNew
            initialCountry={customerCountry?.toLowerCase()}
            value={value || ''}
            onChange={handlePhoneNumber}
            hasIcon={!!entity.iconClassName}
            hasErrors={!!errors.length}
            textAlign={entity.textAlign}
            mobileTextAlign={entity.mobileTextAlign}
            padding={entity.padding}
            mobilePadding={entity.mobilePadding}
            border={entity.border}
            mobileBorder={entity.mobileBorder}
            backgroundColor={entity.backgroundColor}
            mobileBackgroundColor={entity.mobileBackgroundColor}
            color={entity.color}
            mobileColor={entity.mobileColor}
            placeholder={entity.placeholder}
            placeholderColor={entity.placeholderColor}
            mobilePlaceholderColor={entity.mobilePlaceholderColor}
            fontSize={entity.fontSize}
            mobileFontSize={entity.mobileFontSize}
            lineHeight={entity.lineHeight}
            mobileLineHeight={entity.mobileLineHeight}
            boxShadow={entity.boxShadow}
            mobileBoxShadow={entity.mobileBoxShadow}
            countrySelectorStyleProps={{
              dropdownStyleProps: {
                style: { fontSize: entity.fontSize },
                searchInputStyle: { fontSize: entity.fontSize },
              },
            }}
            countrySelectorProps={{
              language: getLanguageCodeByLocale(locale),
            }}
          />
        </FieldWrapperUi>
      )}
      <FieldErrors errors={errors} />
    </StyleWrapper>
  )
}
